export const toNumber = (value: string): number => {
	return (typeof value === 'string')
		? parseFloat(value.replace(/\s+/g, '')) || 0
		: 0;
};